import { routeConstants } from '../../shared/constants';
import Dashboard from "./";

const route = {
  exact: true,
  path: routeConstants.DASHBOARD.route,
  component: Dashboard
};

export default route